import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import AboutPage from './pages/AboutPage';
import ProductConsumerPage from './pages/ProductConsumerPage';
import StartupsPage from './pages/StartupsPage';
import DesignPage from './pages/DesignPage';
import ProductB2BPage from './pages/ProductB2BPage';
import ContactPage from './pages/ContactPage';
import ProductDevtoolMLPage from './pages/ProductDevtoolMLPage';
import RunPage from './pages/RunPage';

function App() {
  return (
    <Router>
      <div className="App min-h-screen bg-page-bg">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/product-consumer" element={<ProductConsumerPage />} />
          <Route path="/startups" element={<StartupsPage />} />
          <Route path="/design" element={<DesignPage />} />
          <Route path="/product-b2b" element={<ProductB2BPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/product-devtool-ml" element={<ProductDevtoolMLPage />} />
          <Route path="/run" element={<RunPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;